"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Styling_1 = require("../../Styling");
exports.DocumentCardPreviewGlobalClassNames = {
    root: 'ms-DocumentCardPreview',
    icon: 'ms-DocumentCardPreview-icon',
    iconContainer: 'ms-DocumentCardPreview-iconContainer'
};
exports.getStyles = function (props) {
    var theme = props.theme, className = props.className, isFileList = props.isFileList;
    var palette = theme.palette;
    var classNames = Styling_1.getGlobalClassNames(exports.DocumentCardPreviewGlobalClassNames, theme);
    return {
        root: [
            classNames.root,
            {
                borderBottom: "1px solid " + palette.neutralLight,
                position: 'relative',
                backgroundColor: isFileList ? palette.white : palette.neutralLighterAlt,
                overflow: "hidden"
            },
            className
        ],
        previewIcon: [
            classNames.iconContainer,
            {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%'
            }
        ],
        icon: [
            classNames.icon,
            {
                left: '10px',
                bottom: '10px',
                position: 'absolute'
            }
        ],
        fileList: {
            padding: '16px 16px 0 16px',
            listStyleType: 'none',
            margin: 0,
            selectors: {
                li: {
                    height: '16px',
                    lineHeight: '16px',
                    marginBottom: '8px',
                    overflow: 'hidden',
                    paddingLeft: '24px',
                    position: 'relative',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                },
                a: {
                    fontSize: Styling_1.FontSizes.small,
                    textDecoration: 'none',
                    color: palette.neutralDark,
                    selectors: {
                        ':hover': {
                            color: palette.themePrimary
                        }
                    }
                }
            }
        },
        fileListIcon: {
            left: 0,
            position: 'absolute',
            top: 0
        },
        fileListOverflowText: {
            padding: '0px 16px 8px 16px',
            display: 'block',
            fontSize: Styling_1.FontSizes.small
        }
    };
};
//# sourceMappingURL=DocumentCardPreview.styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/DocumentCard/DocumentCardPreview.styles.js
// module id = 945
// module chunks = 0